module.exports = __webpack_public_path__ + "img/img5.cda877a4.png";